// Querys and Mutations
import {
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    DELETE,
    IMPORT_FILE,
    GET_ASSISTANCE_DEVICE,
    SAVE_ASSITANCE_DEVICE,
    PROCESS_ASSISTS_FROM_DEVICE,
    GET_ALL
} from '@/graphql/assistance/AsistanceGraphql'

// models
import { Paginator, ResponseDefault, ResponseCustom } from '@/models'
import {
    AssistanceModel,
    AssistanceForm,
    AssistancesWithPagination,
    AssistanceImport,
    ResponseAssistanceDevice,
    SaveAssistanceDeviceForm,
    AssistanceDevice,
    AssistanceDeviceZk,
    FiltersAssistance,
    ResponseAssistanceImportFile
} from '@/models/assistance'

// apollo
import { apolloClient } from '@/apollo'

class AssistanceService {
    async getWithPagination (perPage = 10, page = 1, filters: FiltersAssistance): Promise<AssistancesWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage,
                filters: filters
            }
        })
        const pagination: Paginator = result.data.assistancesWithPagination.paginatorInfo
        const data: AssistanceModel[] = result.data.assistancesWithPagination.data
        const response: AssistancesWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    async getAssistanceDeviceWithFilter (deviceId: number, start: string, end: string): Promise<ResponseAssistanceDevice> {
        const res = await apolloClient.query({
            query: GET_ASSISTANCE_DEVICE,
            variables: {
                deviceId: deviceId,
                start: start,
                end: end
            }
        })
        return res.data.assistanceDevices
    }

    async getAll (filters: FiltersAssistance): Promise<AssistanceModel[]> {
        const res = await apolloClient.query({
            query: GET_ALL,
            variables: {
                filters: filters
            }
        })
        return res.data.assistances
    }

    /**
     * Mutations
     */
     async create (form: AssistanceForm): Promise<AssistanceModel> {
        const result = await apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: form
            }
        })
        return result.data.createAssistance
    }

    async update (id: number, form: AssistanceForm): Promise<AssistanceModel> {
        const result = await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: form
            }
        })
        return result.data.updateAssistance
    }

    async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async importFile (form: AssistanceImport): Promise<ResponseAssistanceImportFile> {
        const result = await apolloClient.mutate({
            mutation: IMPORT_FILE,
            variables: {
                input: form
            }
        })
        return result.data.importAssistance
    }

    async importAssistsFromDevice (deviceID: number, assists: AssistanceDeviceZk[]): Promise<AssistanceDevice[]> {
        const result = await apolloClient.mutate({
            mutation: PROCESS_ASSISTS_FROM_DEVICE,
            variables: {
                input: {
                    deviceId: deviceID,
                    assists: assists
                }
            }
        })
        return result.data.importAssistanceDevice
    }

    async SaveAssistanceDevice (form: SaveAssistanceDeviceForm): Promise<ResponseCustom> {
        try {
            await apolloClient.mutate({
                mutation: SAVE_ASSITANCE_DEVICE,
                variables: {
                    input: form
                }
            })
            return {
                success: true,
                error: false,
                msg: ''
            }
        } catch {
            return {
                success: false,
                error: true,
                msg: 'Se ha presentado un error'
            }
        }
    }
}

export default new AssistanceService()
